import {
  TOOL_NAMES,
  COPILOT_STATUS,
  type CopilotStatus,
} from '@/helpers/aiChat/tools';

/**
 * Tools that should be hidden from the CopilotKit UI
 * These are internal tools that don't need to be displayed to users
 */
export const HIDDEN_TOOL_NAMES = [
  TOOL_NAMES.SELECT_TOOLSET,
  TOOL_NAMES.SELECT_TOOL_SET,
] as const;

/**
 * CopilotKit tool execution status values
 * Re-exported from shared location for convenience
 * @see {@link @/helpers/aiChat/tools}
 */
export { COPILOT_STATUS, type CopilotStatus };
